module.exports = __webpack_public_path__ + "img/page-header-new.a6bcf50e.png";